import React, { useEffect, useState } from 'react';
import { useDocTitle } from '../hooks/CustomHook';
import { handleDownload, isWeChat, isIos } from '../utils/download';

const BG_IMAGE = 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/announceBG.png';
const PAGE_BG = '#eaf6e6';

const AppLanding = () => {
    useDocTitle('族语APP-不要让爱成为遗憾');
    const [showWeChatTip, setShowWeChatTip] = useState(false);
    const [inWeChat, setInWeChat] = useState(false);

    useEffect(() => {
        setInWeChat(isWeChat());

        // 仅本页覆盖分享标题/描述（离开页面时恢复默认）
        const titleMeta = document.querySelector('meta[property="og:title"]');
        const descMeta = document.querySelector('meta[property="og:description"]');
        const urlMeta = document.querySelector('meta[property="og:url"]');
        const nameMeta = document.querySelector('meta[itemprop="name"]');
        const itemDescMeta = document.querySelector('meta[itemprop="description"]');
        const htmlDesc = document.querySelector('meta[name="description"]');

        const prev = {
            title: titleMeta?.getAttribute('content'),
            desc: descMeta?.getAttribute('content'),
            url: urlMeta?.getAttribute('content'),
            name: nameMeta?.getAttribute('content'),
            itemDesc: itemDescMeta?.getAttribute('content'),
            htmlDesc: htmlDesc?.getAttribute('content'),
        };

        titleMeta?.setAttribute('content', '族语APP-不要让爱成为遗憾');
        descMeta?.setAttribute('content', '我们终将老去，但总有一些爱，值得被记住');
        urlMeta?.setAttribute('content', 'https://sayfamily.com/download');
        nameMeta?.setAttribute('content', '族语APP-不要让爱成为遗憾');
        itemDescMeta?.setAttribute('content', '我们终将老去，但总有一些爱，值得被记住');
        htmlDesc?.setAttribute('content', '我们终将老去，但总有一些爱，值得被记住');

        const html = document.documentElement;
        const body = document.body;
        const prevHtmlBg = html.style.backgroundColor;
        const prevBodyBg = body.style.backgroundColor;
        const prevHtmlHeight = html.style.height;
        const prevBodyHeight = body.style.height;

        html.style.backgroundColor = PAGE_BG;
        body.style.backgroundColor = PAGE_BG;
        html.style.height = '100%';
        body.style.height = '100%';

        // 对齐 Safari 真实可视区域（含 offsetTop），避免底部按钮“飞高”
        const syncViewport = () => {
            const vv = window.visualViewport;
            if (vv) {
                html.style.setProperty('--app-vh', `${vv.height}px`);
                html.style.setProperty('--app-vt', `${vv.offsetTop}px`);
            } else {
                html.style.setProperty('--app-vh', `${window.innerHeight}px`);
                html.style.setProperty('--app-vt', '0px');
            }
        };
        syncViewport();
        window.visualViewport?.addEventListener('resize', syncViewport);
        window.visualViewport?.addEventListener('scroll', syncViewport);
        window.addEventListener('resize', syncViewport);
        window.addEventListener('orientationchange', syncViewport);

        return () => {
            if (prev.title != null) titleMeta?.setAttribute('content', prev.title);
            if (prev.desc != null) descMeta?.setAttribute('content', prev.desc);
            if (prev.url != null) urlMeta?.setAttribute('content', prev.url);
            if (prev.name != null) nameMeta?.setAttribute('content', prev.name);
            if (prev.itemDesc != null) itemDescMeta?.setAttribute('content', prev.itemDesc);
            if (prev.htmlDesc != null) htmlDesc?.setAttribute('content', prev.htmlDesc);

            html.style.backgroundColor = prevHtmlBg;
            body.style.backgroundColor = prevBodyBg;
            html.style.height = prevHtmlHeight;
            body.style.height = prevBodyHeight;
            html.style.removeProperty('--app-vh');
            html.style.removeProperty('--app-vt');
            window.visualViewport?.removeEventListener('resize', syncViewport);
            window.visualViewport?.removeEventListener('scroll', syncViewport);
            window.removeEventListener('resize', syncViewport);
            window.removeEventListener('orientationchange', syncViewport);
        };
    }, []);

    const onDownload = (type) => {
        if (type === 'ios' && isWeChat() && isIos()) {
            handleDownload('ios');
            setShowWeChatTip(true);
            return;
        }
        handleDownload(type);
    };

    // 微信：距底 95px；Safari 自带底栏，同样 95px 会显得按钮飞很高，改为贴底更近
    const buttonBottom = inWeChat ? 95 : 24;

    return (
        <div className="app-landing">
            <img
                src={BG_IMAGE}
                alt="族语APP"
                className="app-landing__bg"
            />

            <div
                className="absolute left-0 w-full px-4"
                style={{ bottom: buttonBottom }}
            >
                <div
                    className="max-w-md mx-auto flex"
                    style={{ gap: 24.5 }}
                >
                    <button
                        onClick={() => onDownload('ios')}
                        className="flex-1 flex items-center justify-center gap-1.5 rounded-full py-3 text-[13px] font-semibold text-white shadow-lg transition-all active:scale-95 whitespace-nowrap"
                        style={{ backgroundColor: '#1B1B1D' }}
                    >
                        <svg className="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.572-2.27 1.206-2.98.804-.94 2.142-1.64 3.248-1.68.03.13.05.28.05.43zm4.565 15.71c-.03.09-.463 1.58-1.518 3.12-.9 1.31-1.84 2.61-3.28 2.63-1.41.03-1.87-.84-3.49-.84-1.63 0-2.13.81-3.46.87-1.39.05-2.45-1.42-3.36-2.72-1.84-2.66-3.25-7.52-1.36-10.81.94-1.63 2.62-2.66 4.44-2.69 1.36-.03 2.65.92 3.49.92.83 0 2.4-1.14 4.04-.97.69.03 2.62.28 3.86 2.1-.1.06-2.3 1.34-2.28 4 .03 3.18 2.79 4.24 2.82 4.25z" />
                        </svg>
                        iOS
                    </button>
                    <button
                        onClick={() => onDownload('android')}
                        className="flex-1 flex items-center justify-center gap-1.5 rounded-full py-3 text-[13px] font-semibold text-white shadow-lg transition-all active:scale-95 whitespace-nowrap"
                        style={{ backgroundColor: '#08C18A' }}
                    >
                        <svg className="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.29-.15-.65-.06-.83.22l-1.88 3.24a11.43 11.43 0 00-8.94 0L5.65 5.67c-.19-.28-.54-.37-.83-.22-.3.16-.42.54-.26.85L6.4 9.48A10.78 10.78 0 001 18h22a10.78 10.78 0 00-5.4-8.52zM7 15.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm10 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z" />
                        </svg>
                        Android
                    </button>
                    <button
                        onClick={() => onDownload('harmony')}
                        className="flex-1 flex items-center justify-center gap-1.5 rounded-full py-3 text-[13px] font-semibold shadow-lg transition-all active:scale-95 whitespace-nowrap"
                        style={{ backgroundColor: '#FFFFFF', color: '#08C18A' }}
                    >
                        <svg className="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                            <circle cx="12" cy="12" r="9" />
                        </svg>
                        HarmonyOS
                    </button>
                </div>
            </div>

            {showWeChatTip && (
                <div
                    className="fixed inset-0 z-50 flex flex-col items-end"
                    style={{ backgroundColor: 'rgba(0,0,0,0.72)' }}
                    onClick={() => setShowWeChatTip(false)}
                >
                    <div className="w-full px-5 pt-4 text-right text-white text-sm leading-relaxed">
                        <div className="inline-block text-left">
                            <p className="text-base font-semibold mb-2">无法直接打开 App Store？</p>
                            <p>1. 点击右上角 <span className="font-bold">···</span></p>
                            <p>2. 选择「在 Safari 中打开」</p>
                            <p>3. 再点击 iOS 下载按钮</p>
                            <button
                                className="mt-4 rounded-full px-5 py-2 text-sm font-semibold"
                                style={{ backgroundColor: '#08C18A' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowWeChatTip(false);
                                }}
                            >
                                我知道了
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AppLanding;
